import React from 'react';
import { Button } from '../ui/Button';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-beige-light" data-id="element-123">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-124">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-125">
          {/* Text Content */}
          <div className="max-w-2xl mx-auto lg:mx-0 text-center lg:text-left order-2 lg:order-1" data-id="element-126">
            <div className="inline-flex items-center space-x-2 bg-cream px-4 py-2 rounded-full mb-6 border border-beige shadow-sm" data-id="element-127">
              <span className="w-2 h-2 rounded-full bg-gold animate-pulse" data-id="element-128"></span>
              <span className="text-sm font-body font-medium text-taupe-light uppercase tracking-wider" data-id="element-129">
                Para mujeres 45+
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-balance" data-id="element-130">
              El Método de 21 Días para{' '}
              <span className="text-gold italic" data-id="element-131">"Apagar"</span> el Cortisol y
              Reactivar tu Metabolismo después de los 50
            </h1>

            <h2 className="text-lg md:text-xl text-taupe-light font-body leading-relaxed mb-8 text-balance" data-id="element-132">
              Deja de luchar contra tu cuerpo y descubre por qué las dietas
              tradicionales ya no te funcionan (y cómo una rutina nocturna de 10
              minutos puede cambiarlo todo).
            </h2>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-133">
              <Button size="lg" onClick={scrollToPricing} className="w-full sm:w-auto" data-id="element-134">
                ¡Quiero mi copia hoy!
              </Button>
              <p className="text-sm text-taupe-light font-body mt-2 sm:mt-0" data-id="element-135">
                Acceso instantáneo • Pago seguro
              </p>
            </div>
          </div>

          {/* Hero Image */}
          <div className="relative order-1 lg:order-2" data-id="element-136">
            <div className="absolute inset-0 bg-gold/10 rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-137"></div>
            <img src="https://cdn.magicpatterns.com/uploads/vuaesUC2ZRxBrGPdCXZuG3/imagen_portada_3.png" alt="Mujer madura sonriendo, sintiéndose saludable y en paz" className="rounded-3xl shadow-soft w-full object-cover aspect-[4/3] lg:aspect-auto lg:h-[600px]" data-id="element-138" />

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -left-6 md:bottom-8 md:-left-12 bg-cream p-4 rounded-2xl shadow-soft border border-beige flex items-center gap-4 animate-bounce" style={{
            animationDuration: '3s'
          }} data-id="element-139">
              <div className="w-12 h-12 rounded-full bg-olive/10 flex items-center justify-center" data-id="element-140">
                <span className="text-2xl" data-id="element-141">✨</span>
              </div>
              <div data-id="element-142">
                <p className="font-heading font-bold text-taupe" data-id="element-143">
                  Resultados en 7 días
                </p>
                <p className="text-xs font-body text-taupe-light" data-id="element-144">
                  Sin dietas extremas
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}